var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.mask)?_c('v-text-field',_vm._g(_vm._b({directives:[{name:"mask",rawName:"v-mask",value:({ mask: [..._vm.mask], tokens: _vm.tokens }),expression:"{ mask: [...mask], tokens: tokens }"}],attrs:{"label":_vm.labelValue,"rules":_vm.rulesArray},on:{"input":_vm.onInput}},'v-text-field',_vm.$attrs,false),_vm.$listeners)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }